import React, { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import Heading from '@components/ui/Heading';
import type { StoreHour } from '@adapters/prismic/fetching/stores/types';

import styles from './StoreHeader.module.scss';

export const StoreHeader = ({
  storeHours,
}: {
  storeHours: StoreHour[];
}): ReactElement => {
  const today = storeHours[0];
  const { t } = useTranslation('stores');
  const generateMessage = () => {
    if (today?.dow_notice) {
      return today.dow_notice;
    }
    if (
      !today?.open ||
      !today?.close ||
      today.close.toLowerCase().includes('close') ||
      today.open.toLowerCase().includes('close') ||
      today.close.toLowerCase().includes('ferm') ||
      today.open.toLowerCase().includes('ferm')
    ) {
      if (today?.name) {
        return t('closed.today.reason', { reason: today.name });
      }
      return t('closed.today');
    }
    const translatedDay = t(today.day);
    if (today?.name) {
      return t('open.special', {
        day: translatedDay,
        name: today.name,
        open: today.open,
        close: today.close,
      });
    }
    return t('open', {
      day: translatedDay,
      open: today.open,
      close: today.close,
    });
  };
  const message = generateMessage();

  return (
    <Heading semanticLevel="h2" styleLevel="2" className={styles.dynamicHeader}>
      {message}
    </Heading>
  );
};
